module.exports = __webpack_public_path__ + "static/media/featuredAthletes.15d4dff3.png";